import { render, staticRenderFns } from "./sys0020.vue?vue&type=template&id=3f4e50a4&scoped=true"
import script from "./sys0020.vue?vue&type=script&lang=js"
export * from "./sys0020.vue?vue&type=script&lang=js"
import style0 from "./sys0020.vue?vue&type=style&index=0&id=3f4e50a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4e50a4",
  null
  
)

export default component.exports